import React from "react";
import LabelWithIcons from "./LabelWithIcons";

// Um numero com o seu rotulo e, se houver, uma linha de detalhe (o periodo anterior, uma taxa) e uma
// ressalva atras de um icone (`info`), logo a seguir a ultima palavra do rotulo.
const StatTile = ({ label, value, detail, info }) => (
  <div className="rounded-xl border p-4 h-full" style={{ borderColor: "var(--color-border)", backgroundColor: "var(--color-surface)" }}>
    <p className="text-xs" style={{ color: "var(--color-text-secondary)" }}>
      <LabelWithIcons text={label} info={info} />
    </p>
    <p className="text-2xl font-semibold mt-1 tabular-nums" style={{ color: "var(--color-text-primary)" }}>
      {value}
    </p>
    {detail && (
      <p className="text-xs mt-1" style={{ color: "var(--color-text-muted)" }}>
        {detail}
      </p>
    )}
  </div>
);

export default StatTile;
